import React, { useState, useEffect } from "react";
import { Button } from "../../../atoms";
import "./subscription-failure.m.css";

export function SubscriptionFailure() {
  const [errorMessage, setErrorMessage] = useState("");

  useEffect(() => {
    const searchParams = new URLSearchParams(window.location.search);
    const error = searchParams.get("errorMsg");
    console.log("FAILURE LOG ----", searchParams, error);
    setErrorMessage(error || "Something went wrong.");
  }, []);

  return (
    <div styleName="container">
      <div styleName="message-section">
        {/* <p styleName="title">{errorMessage}</p> */}
        {errorMessage === 'user closed the payment' ? (
          <>
            <p styleName="title"> ❌ Payment Unsuccessful</p>
            <p styleName="description">The subscription could not be complete as the process was cancelled in-between. Please try again to enjoy the ad-free experience.</p>
          </>
        ) : errorMessage === 'You already have an active subscription. Please visit Manage Subscription page to check further details.' ? (
          <><p styleName="title">Dear User</p><p styleName="description">{errorMessage}</p></>
        ) : (
          <p styleName="title">{errorMessage}</p>
        )}
      </div>
      <div styleName="action-buttons">
        {errorMessage === 'user closed the payment' ? (
        <Button href="/subscription" customStyleName="bg-brand-primary">
          Try Again
        </Button>
        ) : (
          <><Button href="/" customStyleName="bg-brand-primary">
              Browse Ad-Free
            </Button>
            <Button href="/subscription" customStyleName="">
              Manage Subscription
            </Button>
          </>
        )}
      </div>
    </div>
  );
}
